export default __webpack_public_path__ + "img/0df92c213dc4965178e8fa0f1d5f2eba.svg";